<script>
    import { onMount } from "svelte";
    import Split from "split-grid";

    import Handle from "../svg/Handle.svelte";

    onMount(() => {
		Split({
			// gutters specified in options
			columnGutters: [
				{
					track: 2,
					element: document.querySelector(".gutter"),
				},
			],
		});
	});
</script>

<style>
    .gutter {
        grid-area: gutter;
        background-color: var(--silver);
        cursor: col-resize;
    }

    .gutter > :global(svg) {
        padding: 0;
        margin: 0;
    }

    .gutter__handle--container {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        height: 100%;
        gap: 0px;
    }
</style>

<div class="gutter">
    <div class="gutter__handle--container">
        <Handle />
    </div>
</div>
